module.exports = __webpack_public_path__ + "img/logo.1ee768f4.webp";